import isUndefined from 'lodash/isUndefined';
import isPlainObject from 'lodash/isPlainObject';
import mergeDeep from './mergeDeep';

export default function dictToObject(dict) {
  if (dict == null) {
    return null;
  }

  if (!isPlainObject(dict)) {
    return dict;
  }

  if (Object.keys(dict).length === 1 && '' in dict) {
    return dict[''];
  }

  return Object.entries(dict)
    .map(([k, v]) => {
      if (/^#\//.test(k)) {
        return [k.slice(2), v];
      }

      if (/^\//.test(k)) {
        return [k.slice(1), v];
      }

      return [k, v];
    })
    .sort()
    .reduce((o, [k, v]) => {
      if (isUndefined(v)) {
        return o;
      }

      const segments = k.split('/');
      const nestedObj = segments.reduceRight((_v, _k) => ({ [_k]: _v }), v);

      return mergeDeep(o, nestedObj);
    }, {});
}
